import { render } from "./CustomDateInput.vue?vue&type=template&id=01f0329b"
import script from "./CustomDateInput.vue?vue&type=script&lang=js"
export * from "./CustomDateInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__